import { Link, useMatch } from "react-router-dom"
import cn from "classnames"

import styles from "./styles.module.scss"

import { UserAvatar } from "components/UserAvatar"

interface Props {
    isAdaptive?: boolean
    className?: string
}

export function HeaderUserPicture({ isAdaptive = true, className }: Props) {
    const match = useMatch("/my/userinfo")
    const _className = cn(styles.headerUserPicture, className)

    if (match) {
        return <UserAvatar size="XS" className={_className} isAdaptive={isAdaptive} />
    }

    return (
        <Link to="/my/userinfo" className={styles.headerUserPictureLink}>
            <UserAvatar size="XS" className={_className} isAdaptive={isAdaptive} />
        </Link>
    )
}
